import { ApiState } from "@/store/general.types";
import { mutate } from "@/store/plugins/mutation-handler";
import { ExactDuplicateCitation, DuplicateCitationState, PossibleDuplicateCitation, UndoStackDetails, ScreeningCountByFile } from "./duplicate-citation.types";
import { MarkCitationAsDuplicateResult } from "../citation/citation.types";



export const duplicateCitationMutations = {
    GET_DUPLICATE_CITATION(state: DuplicateCitationState, newState: ApiState<ExactDuplicateCitation>) {
        mutate(state, newState, 'getDuplicateCitation')
    },
    GET_POSSIBLE_DUPLICATE_CITATIONS(state: DuplicateCitationState, newState: ApiState<PossibleDuplicateCitation>) {
        mutate(state, newState, 'getPossibleDuplicateCitations')
    },
    MARK_CITATION_AS_DUPLICATE(state: DuplicateCitationState, newState: ApiState<MarkCitationAsDuplicateResult>) {
        mutate(state, newState, 'markCitationAsDuplicate');
    },
    // JIRA: SUMDEV-2964
    MARK_CITATION_AS_NOT_DUPLICATE(state: DuplicateCitationState, newState: ApiState<{ markedCitationIds: number[] }>) {
        mutate(state, newState, 'markCitationAsNotDuplicate');
    },

    // JIRA: SUMDEV-2964
    REPLACE_PRIMARY_REFERENCE_V2(state: DuplicateCitationState, newState: ApiState<{ success: boolean; message: string; dismantledClusters?: number }>) {
        mutate(state, newState, 'replacePrimaryReferenceV2');
    },

    // JIRA: SUMDEV-2964
    REPLACE_PRIMARY_REFERENCE_POSSIBLE_V2(state: DuplicateCitationState, newState: ApiState<{ success: boolean; message: string; removedMembers?: number }>) {
        mutate(state, newState, 'replacePrimaryReferencePossibleV2');
    },

    // JIRA: SUMDEV-2964
    UNDO_FILE_IMPORT_V2(state: DuplicateCitationState, newState: ApiState<{ success: boolean; message: string; removedCitations: number }>) {
        mutate(state, newState, 'undoFileImportV2');
    },
    // JIRA: SUMDEV-2964
    MARK_CITATION_AS_MANUALLY_MARKED_DUPLICATE(state: DuplicateCitationState, newState: ApiState<{ markedCitationIds: number[] }>) {
        mutate(state, newState, 'markCitationAsManuallyMarkedDuplicate');
    },
    // JIRA: SUMDEV-2964
    GET_MANUALLY_MARKED_DUPLICATE_CITATIONS_V2(state: DuplicateCitationState, newState: ApiState<ExactDuplicateCitation>) {
        mutate(state, newState, 'getManuallyMarkedDuplicateCitationsV2');
    },
    UPDATE_CITATION_STATUS(state: DuplicateCitationState, newState: ApiState<string>) {
        mutate(state, newState, 'updateCitationStatus');
    },
    REPLACE_PRIMARY_REFERENCE(state: DuplicateCitationState, newState: ApiState<ExactDuplicateCitation>) {
        mutate(state, newState, 'replacePrimaryReference');
    },
    DUPLICATE_CITATION_COUNT(state: DuplicateCitationState, newState: ApiState<ExactDuplicateCitation>) {
        mutate(state, newState, 'duplicateCitationCount')
    },
    GET_DUPLICATE_CITATION_COUNT_BY_FILE_ID(state: DuplicateCitationState, newState: ApiState<ExactDuplicateCitation>) {
        mutate(state, newState, 'getDuplicateCitationCountByFileId');
    },
    GET_MANUALLY_MARKED_DUPLICATE_CITATION(state: DuplicateCitationState, newState: ApiState<ExactDuplicateCitation>) {
        mutate(state, newState, 'getManuallyMarkedDuplicateCitation');
    },
    GET_DUPLICATE_CITATION_GROUP_COUNT(state: DuplicateCitationState, newState: ApiState<ExactDuplicateCitation>) {
        mutate(state, newState, 'getDuplicateCitationGroupCount');
    },
    GET_REMOVED_DUPLICATE_UNDO_STACK_DETAILS(state: DuplicateCitationState, newState: ApiState<UndoStackDetails>) {
        mutate(state, newState, 'getRemovedDuplicateUndoStackDetails');
    },
    GET_MANUALLY_REMOVED_DUPLICATE_UNDO_STACK_DETAILS(state: DuplicateCitationState, newState: ApiState<UndoStackDetails>) {
        mutate(state, newState, 'getManuallyRemovedDuplicateUndoStackDetails');
    },
    GET_PARTIAL_DUPLICATE_UNDO_STACK_DETAILS(state: DuplicateCitationState, newState: ApiState<UndoStackDetails>) {
        mutate(state, newState, 'getPartialDuplicateUndoStackDetails');
    },
    // JIRA: SUMDEV-2964
    GET_REMOVED_DUPLICATE_UNDO_STACK_DETAILS_V2(state: DuplicateCitationState, newState: ApiState<UndoStackDetails>) {
        mutate(state, newState, 'getRemovedDuplicateUndoStackDetailsV2');
    },
    // JIRA: SUMDEV-2964
    GET_MANUALLY_REMOVED_DUPLICATE_UNDO_STACK_DETAILS_V2(state: DuplicateCitationState, newState: ApiState<UndoStackDetails>) {
        mutate(state, newState, 'getManuallyRemovedDuplicateUndoStackDetailsV2');
    },
    REVERT_CITATION_DUPLICATION_STATUSES(state: DuplicateCitationState, newState: ApiState<void>) {
        mutate(state, newState, 'revertCitationDuplicationStatuses');
    },
    // JIRA: SUMDEV-2964
    REVERT_CITATION_DUPLICATION_STATUSES_V2(state: DuplicateCitationState, newState: ApiState<{ success: boolean; message: string }>) {
        mutate(state, newState, 'revertCitationDuplicationStatusesV2');
    },
    GET_SCREENING_COUNT_BY_FILE(state: DuplicateCitationState, newState: ApiState<ScreeningCountByFile>) {
        mutate(state, newState, 'getScreeningCountByFile');
    },
    // JIRA: SUMDEV-2964
    GET_CLUSTER_BASED_DUPLICATE_COUNTS_BY_FILE(state: DuplicateCitationState, newState: ApiState<{
        exactDuplicateCounts: Array<{ citationFileId: number; count: number }>;
        possibleDuplicateCounts: Array<{ citationFileId: number; count: number }>;
    }>) {
        mutate(state, newState, 'getClusterBasedDuplicateCountsByFile');
    },
    // JIRA: SUMDEV-2964 - Possible duplicates undo mutations
    GET_POSSIBLE_DUPLICATES_UNDO_STACK_DETAILS_V2(state: DuplicateCitationState, newState: ApiState<UndoStackDetails>) {
        mutate(state, newState, 'getPossibleDuplicatesUndoStackDetailsV2');
    },
    REVERT_POSSIBLE_DUPLICATES_REMOVAL_V2(state: DuplicateCitationState, newState: ApiState<any>) {
        mutate(state, newState, 'revertPossibleDuplicatesRemovalV2');
    }
}
